import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import NewsPage from "./pages/NewsPage";

export const browserHistory = createBrowserHistory();

const UserRouter: React.FC = (props) => {
  return (
    <Switch>
      <Route path="/news" component={NewsPage} />
    </Switch>
  );
};

export default UserRouter;
